import { jsx, jsxs } from "react/jsx-runtime";
import {
  priceClasses,
  generateAriaLabel,
  getNegativeSign,
  getElementType
} from "@ingka/price-shared";
const Price = (props) => {
  const {
    prefix = "",
    decimalSign = "",
    subscriptLabel = "",
    integerValue,
    decimalValue = "",
    size = "medium",
    fixedSize = false,
    currencyVerticalAlignment = "super",
    decimalVerticalAlignment = "super",
    currencyLabel = "",
    currencySpacing = "none",
    captionPrefix = "",
    captionSuffix = "",
    currencyPosition = "leading",
    regularFontWeight = false,
    strikeoutPrice = false,
    bti = false,
    subtle = false,
    className = "",
    ...other
  } = props;
  const baseClass = `${prefix}price`;
  const classes = priceClasses({
    baseClass,
    currencyPosition,
    currencySpacing,
    strikeoutPrice,
    fixedSize,
    currencyVerticalAlignment,
    decimalVerticalAlignment,
    subtle,
    bti,
    size,
    regularFontWeight,
    className
  });
  const PriceElement = getElementType({ bti });
  const negativeSign = getNegativeSign({ integerValue });
  const ariaLabel = generateAriaLabel({
    captionPrefix,
    captionSuffix,
    negativeSign: negativeSign || "",
    currencyLabel,
    currencyPosition,
    decimalSign,
    decimalValue,
    subscriptLabel,
    integerValue
  });
  return /* @__PURE__ */ jsxs(PriceElement, { className: classes, ...other, children: [
    /* @__PURE__ */ jsxs("span", { "aria-hidden": "true", className: "notranslate", children: [
      /* @__PURE__ */ jsxs("span", { className: `${baseClass}__nowrap`, children: [
        negativeSign && /* @__PURE__ */ jsx("span", { className: `${baseClass}__minus`, children: negativeSign }),
        currencyPosition === "leading" && /* @__PURE__ */ jsx("span", { className: `${baseClass}__currency`, children: currencyLabel }),
        /* @__PURE__ */ jsx("span", { className: `${baseClass}__integer`, children: negativeSign ? integerValue.slice(1) : integerValue })
      ] }),
      Boolean(decimalValue) && /* @__PURE__ */ jsxs("span", { className: `${baseClass}__decimal`, children: [
        Boolean(decimalSign) && /* @__PURE__ */ jsx("span", { className: `${baseClass}__separator`, children: decimalSign }),
        decimalValue.trim()
      ] }),
      currencyPosition === "trailing" && /* @__PURE__ */ jsx("span", { className: `${baseClass}__currency`, children: currencyLabel }),
      Boolean(subscriptLabel) && /* @__PURE__ */ jsx("span", { className: `${baseClass}__subscript`, children: subscriptLabel })
    ] }),
    /* @__PURE__ */ jsx("span", { className: `${baseClass}__sr-text`, children: ariaLabel })
  ] });
};
var Price_default = Price;
export {
  Price_default as default
};
